@if (!readOnly()) {
  @if (compactMode() && files().length === 0) {
    <div
      class="relative inline-block"
      cdkOverlayOrigin
      #overlayOrigin="cdkOverlayOrigin">
      <app-button
        [text]="buttonLabel()"
        [type]="ButtonType.SecondarySubtle"
        [borderRadius]="'rounded-lg'"
        [leftIcon]="'/assets/svg/image.svg'"
        [showSpinner]="uploading"
        [spinnerClass]="'-scale-x-100'"
        [spinnerAnimationDirection]="'reverse'"
        (clickEmitter)="togglePopover($event)" />

      <app-popover
        [origin]="overlayOrigin"
        [open]="popoverOpen"
        [title]="buttonLabel()"
        [panelClass]="'max-w-[calc(100vw-2rem)]'"
        (closed)="closePopover()">
        <button
          type="button"
          class="flex w-full items-center gap-3 px-4 py-2.5 text-sm text-secondary transition-colors hover:bg-secondary_hover"
          (click)="onTakePhoto()">
          <svg-icon
            class="w-5 h-5 text-quarternary"
            src="/assets/svg/camera.svg"
            svgClass="w-5 h-5" />
          Take a photo
        </button>
        <button
          type="button"
          class="flex w-full items-center gap-3 px-4 py-2.5 text-sm text-secondary transition-colors hover:bg-secondary_hover"
          (click)="onUploadFromDevice()">
          <svg-icon
            class="w-5 h-5 text-quarternary"
            src="/assets/svg/image.svg"
            svgClass="w-5 h-5" />
          Upload from device
        </button>
      </app-popover>
    </div>
  } @else {
    <div class="relative">
      <div class="grid grid-cols-3 gap-2">
        <ng-content />

        @if (files().length < maxFiles()) {
          <div class="relative">
            <button
              cdkOverlayOrigin
              #overlayOrigin="cdkOverlayOrigin"
              type="button"
              class="flex aspect-square w-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-primary bg-primary px-4 text-center transition-colors hover:bg-primary_hover"
              (click)="togglePopover($event)">
              @if (uploading) {
                <div
                  class="w-5 h-5 rounded-full border-2 border-brand-primary border-t-transparent animate-spin"></div>
              } @else {
                <span class="text-sm font-medium text-brand-primary">{{
                  buttonLabel()
                }}</span>
                @if (files().length >= maxFiles() - 1) {
                  <span class="mt-1 text-xs text-tertiary"
                    >Max. {{ maxFiles() }} pictures</span
                  >
                }
              }
            </button>

            <app-popover
              [origin]="overlayOrigin"
              [open]="popoverOpen"
              [title]="buttonLabel()"
              [panelClass]="'max-w-[calc(100vw-2rem)]'"
              (closed)="closePopover()">
              <button
                type="button"
                class="flex w-full items-center gap-3 px-4 py-2.5 text-sm text-secondary transition-colors hover:bg-secondary_hover"
                (click)="onTakePhoto()">
                <svg
                  class="w-5 h-5 text-quarternary"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round">
                  <path
                    d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
                Take a photo
              </button>
              <button
                type="button"
                class="flex w-full items-center gap-3 px-4 py-2.5 text-sm text-secondary transition-colors hover:bg-secondary_hover"
                (click)="onUploadFromDevice()">
                <svg
                  class="w-5 h-5 text-quarternary"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
                Upload from device
              </button>
            </app-popover>
          </div>
        } @else {
          <div
            class="flex aspect-square w-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-disabled bg-primary px-4 text-center">
            <span class="text-xs text-tertiary"
              >{{ maxFiles() }} pictures limit reached</span
            >
          </div>
        }
      </div>
    </div>
  }
}

<input
  #cameraInput
  type="file"
  [accept]="accept()"
  capture="environment"
  class="hidden"
  (change)="onFileSelected($event)" />
<input
  #fileInput
  type="file"
  [accept]="accept()"
  class="hidden"
  (change)="onFileSelected($event)" />

@if (helperText()) {
  <p class="mt-2 text-xs text-tertiary">{{ helperText() }}</p>
}
